// Feature flags exposés par le backend (source unique : backend TRAIL_ENABLED).
// Défaut SÛR = trail désactivé si l'appel échoue (on ne promet jamais une feature en sommeil).
import { useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULT_FEATURES = { trail_enabled: false };
let _cache = null;
let _inflight = null;

export async function getFeatures() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = api
    .get("/public/features")
    .then((r) => {
      _cache = { ...DEFAULT_FEATURES, ...(r.data || {}) };
      return _cache;
    })
    .catch(() => ({ ...DEFAULT_FEATURES }))
    .finally(() => {
      _inflight = null;
    });
  return _inflight;
}

export function useFeatures() {
  const [features, setFeatures] = useState(_cache || DEFAULT_FEATURES);
  useEffect(() => {
    let alive = true;
    getFeatures().then((f) => {
      if (alive) setFeatures(f);
    });
    return () => {
      alive = false;
    };
  }, []);
  return features;
}
